import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const PurchasesreqViewapproval = () => {
   useAuthRedirect();
  const [data, setData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const user = localStorage.getItem("username");
  const [selectedType, setSelectedType] = useState("Emergency"); 
  const [loading, setLoading] = useState(false);
   const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

    //✅ Permission checks (safe even if perms not yet loaded; will be false)
            const canView  = hasPermission("Purchase Requisition Approval", "view");
            const canEntry = hasPermission("Purchase Requisition Approval", "entry");
            /////////////////////////////////////////////////////////////
       

  useEffect(() => {
    if (selectedBranch && selectedType) {
      setLoading(true);
      axios.get(`https://rfs2.infraconsoft.net.in/api/purchase_req_appr?branch_code=${selectedBranch}&type=${selectedType}`)
        .then((response) => {
          setData(response.data.waitingList);
          setFilteredData(response.data.waitingList);
        })
        .catch((error) => {
          console.error("Error fetching waitingList:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedBranch, selectedType]);

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };

  const handleApprove = async (fld_purnumber) => {
    if (!fld_purnumber) return;
  
    // Show confirmation popup
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to approve this bill?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve!",
      cancelButtonText: "Cancel",
    });
  
    if (result.isConfirmed) {
      try {
        const response = await axios.post("https://rfs2.infraconsoft.net.in/api/streReq_approve", { fld_purnumber, user });
        
        if (response.data.success) {
          // Show success alert
          Swal.fire({
            title: "Approved!",
            text: "Request Approved Successfully!",
            icon: "success",
          });
        } else {
          Swal.fire({
            title: "Failed!",
            text: "Failed to Approve .",
            icon: "error",
          });
        }
        navigate(`/inventory/add_PrNew/${fld_purnumber}`)
      } catch (error) {
        console.error("Error approving bill:", error);
        Swal.fire({
          title: "Error!",
          text: "Error processing approval.",
          icon: "error",
        });
      }
    }
  };

 const handleDisapprove = async (fld_purnumber) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "Do you really want to disapprove this Request?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Disapprove!",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    try {
      const response = await axios.post("https://rfs2.infraconsoft.net.in/api/streReq_disapprove", {
        fld_purnumber,
        user,
      });

      if (response.data.success) {
        Swal.fire("Disapproved!", "Request Disapproved!", "success");

        // Refresh data after disapproval
        setLoading(true);
        axios.get(`https://rfs2.infraconsoft.net.in/api/purchase_req_appr?branch_code=${selectedBranch}&type=${selectedType}`)
          .then((res) => {
            setData(res.data.waitingList);
            setFilteredData(res.data.waitingList);
          })
          .catch((err) => console.error("Error fetching waitingList:", err))
          .finally(() => setLoading(false));
      } else {
        Swal.fire("Failed!", "Failed to Disapprove Bill.", "error");
      }
    } catch (error) {
      console.error("Error disapproving bill:", error);
      Swal.fire("Error!", "Error processing disapproval.", "error");
    }
  }
};

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.fld_purnumber && item.fld_purnumber.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_dept && item.fld_dept.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_inref && item.fld_inref.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); 
  };

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Purchase Requisition Approval</h2>
          <div>
            <Time />
          </div>
        </section>

        
                      <div className="vehicle-class">
  <div>
    <p>Requirement Basis :</p>
                   <select 
value={selectedType} onChange={handleTypeChange} 
            required 
            className="branch-select"
          >
            <option value="Emergency">Emergency</option>
    <option value="Urgent">Urgent</option>
    <option value="Ordinary">Ordinary</option>
          </select>
  </div>
  </div>



 {/* Search Filter */}
 <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by Req No.." value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Requisition No</th>
                <th>Branch</th>
                <th>Date</th>
                <th>Department</th>
                <th>H.O.D</th>
                <th>Indent Ref</th>
                <th>Head Material</th>
                {canEntry && (
                  <>
                <th>Approval</th>
                <th>Dis Approval</th>
                </>
                )}
                
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                     <Link to={`/inventory/viewpr_new/${item.fld_purnumber}`}>{item.fld_purnumber}</Link></td>
                    <td>{item.fld_branchcode}</td>
                 
                    <td>{item.fld_duedate ? new Date(item.fld_duedate).toISOString().split("T")[0] : ""}</td>
                    <td>{item.fld_dept}</td>
                    <td>{item.fld_hod}</td>
                    <td>{item.fld_inref}</td>
                    <td>{item.fld_headmet}</td>
                    {canEntry && (
                      <>
                    <td> <button class="approve-btn" onClick={() => handleApprove(item.fld_purnumber)}>✅ Approve</button></td>
                    <td><button class="disapprove-btn" onClick={() => handleDisapprove(item.fld_purnumber)} >❌ Disapprove</button></td>
                    </>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

         {/* Pagination Controls */}
         <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)}  disabled={currentPage === 1}>Previous</button>
          {[...Array(Math.ceil(filteredData.length / itemsPerPage))].map((_, index) => (
            <button key={index} onClick={() => paginate(index + 1)} className={currentPage === index + 1 ? 'active' : ''}>{index + 1}</button>
          ))}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default PurchasesreqViewapproval;
